export default function Footer() {
  return (
    <footer className="border-t border-gg-border bg-gg-bg mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid sm:grid-cols-3 gap-8 text-sm">
        <div>
          <p className="font-heading text-2xl text-gg-green leading-none">
            Graceful Garden
          </p>
          <p className="font-heading italic text-gg-brown text-lg mt-1">
            Coaching &amp; Design
          </p>
          <p className="text-gg-muted mt-4 max-w-xs">
            Hands-on homestead education rooted in soil, science, and the
            quiet practice of growing things on purpose.
          </p>
        </div>
        <div className="text-gg-muted">
          <p className="uppercase tracking-[0.18em] text-xs text-gg-brown font-semibold mb-3">
            Contact
          </p>
          <p>Heather Mich</p>
          <p>Chino Valley, AZ · Yavapai County</p>
          <p className="mt-2">(805) 444-6144</p>
          <p>
            <a className="hover:text-gg-green" href="mailto:Heather@gracefulgardencoaching.com">
              Heather@gracefulgardencoaching.com
            </a>
          </p>
          <p className="text-xs italic mt-3">
            Class address shared by email after registration.
          </p>
        </div>
        <div className="text-gg-muted">
          <p className="uppercase tracking-[0.18em] text-xs text-gg-brown font-semibold mb-3">
            ESA Vendor
          </p>
          <p>
            <span className="font-medium text-[var(--gg-text)]">
              CLASSWALLET DIRECT PAY
            </span>
          </p>
          <p>Graceful Garden Coaching — Heather Mich</p>
          <p>AZ, Yavapai County</p>
        </div>
      </div>
      <div className="border-t border-gg-border py-4 text-center text-xs text-gg-muted">
        © {new Date().getFullYear()} Graceful Garden Coaching &amp; Design. All rights reserved.
        <span className="mx-2 text-gg-border">·</span>
        <a className="hover:text-gg-green" href="/privacy">Privacy</a>
        <span className="mx-2 text-gg-border">·</span>
        <a className="hover:text-gg-green" href="/terms">Terms &amp; Refund</a>
      </div>
    </footer>
  );
}
